import { Grid } from "@mui/material";
import Chart from "react-apexcharts";
import Header from "../layouts/Header";
import React, { useState, useEffect } from "react";
import { instance } from "../utils/api";
function Dashboard() {
    const cl = "app-page-dashboard";
    const [statisticsData, setStatisticsData] = useState([]);
    const [statusData, setStatusData] = useState([]);
    const [priorityData, setPriorityData] = useState([]);
    const userRole = localStorage.getItem("userRole")
      const fetchData = async () => {
        try {
            let response;
            if (userRole === 'admin') {
                response = await instance.get("tickets/statistics/all");
              } else if (userRole === 'agent') {
                response = await instance.get("agents/tickets/count/statistics");
              }
          const data = response.data;
    console.log(data)
    setStatisticsData(data);
        } catch (error) {
          console.error("Error fetching data for priority chart: ", error);
        }
      };
      
      const fetchStatusChartData = async () => {
        try {
            let response;
            if (userRole === 'admin') {
              response = await instance.get("tickets/count/status");
            } else if (userRole === 'agent') {
              response = await instance.get("agents/tickets/count/byStatus");
            }
          const data = response.data;
      console.log(data)
      setStatusData(data);
        } catch (error) {
          console.error("Error fetching data for status chart: ", error);
        }
      };

      const fetchPriorityChartData = async () => {
        try {
            let response;
            if (userRole === 'admin') {
              response = await instance.get("tickets/count/priority");
            } else if (userRole === 'agent') {
              response = await instance.get("agents/tickets/count/byPriority");
            }
        
          const data = response.data;
      console.log(data)
      setPriorityData(data);
        } catch (error) {
          console.error("Error fetching data for priority chart: ", error);
        }
      };
      
      
      useEffect(() => {
        fetchData();
        fetchStatusChartData(); 
        fetchPriorityChartData();
      }, []);
      
    return (
        <>
        <div className="dashboardpage">
            <Header/>
        </div>
            <div className='app-page-body'>
                <div className='app-page-wrapper'>
                    <div className={`${cl}`}>
                        <div className={`${cl}__cardlist`}>
                            <Grid container spacing={2.5}>
                                <Grid item md={4} lg={2.4}>
                                    <div className={`${cl}__carditem --blue`}>
                                        <div className={`${cl}__carditem--image`}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={512}
                                                height={512}
                                                viewBox="0 0 24 24"

                                            >
                                                <path d="M21.5 22h-19A2.503 2.503 0 0 1 0 19.5v-2a.5.5 0 0 1 .5-.5H1c1.103 0 2-.897 2-2s-.897-2-2-2H.5a.5.5 0 0 1-.5-.5v-2C0 9.122 1.122 8 2.5 8h19c1.378 0 2.5 1.122 2.5 2.5v2a.5.5 0 0 1-.5.5H23a2.002 2.002 0 0 0-1.414 3.414c.377.378.879.586 1.413.586h.5a.5.5 0 0 1 .5.5v2A2.502 2.502 0 0 1 21.5 22zM1 18v1.5c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5V18h-.001a2.979 2.979 0 0 1-2.12-.878A2.982 2.982 0 0 1 20 15c0-1.654 1.346-3 3-3v-1.5c0-.827-.673-1.5-1.5-1.5h-19C1.673 9 1 9.673 1 10.5V12c1.654 0 3 1.346 3 3s-1.346 3-3 3z" />
                                                <path d="M8.5 10a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 1 0v1a.5.5 0 0 1-.5.5zM8.5 18.461a.5.5 0 0 1-.5-.5V16.27a.5.5 0 0 1 1 0v1.692a.5.5 0 0 1-.5.499zm0-4.23a.5.5 0 0 1-.5-.5v-1.692a.5.5 0 0 1 1 0v1.692a.5.5 0 0 1-.5.5zM8.5 22a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 1 0v1a.5.5 0 0 1-.5.5z" />
                                                <path d="M2.5 9a.498.498 0 0 1-.175-.968l15.9-5.937c.773-.29 1.681.144 1.945.923l1.803 5.321a.5.5 0 0 1-.947.321l-1.803-5.321a.511.511 0 0 0-.649-.308l-15.9 5.937A.482.482 0 0 1 2.5 9z" />
                                            </svg>
                                        </div>
                                        <div className={`${cl}__carditem--content`}>
                                            <h1>{statusData.totalTickets}</h1>
                                            <p>Total Tickets</p>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item md={4} lg={2.4}>
                                    <div className={`${cl}__carditem --red`}>
                                        <div className={`${cl}__carditem--image`}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={512}
                                                height={512}
                                                fillRule="evenodd"
                                                strokeLinejoin="round"
                                                strokeMiterlimit={2}
                                                clipRule="evenodd"
                                                viewBox="0 0 32 32"

                                            >
                                                <path d="M16.75 17.025v-6.151a.75.75 0 0 0-1.5 0v6.151a.75.75 0 0 0 1.5 0z" />
                                                <path d="m15.625 16.376-4.101 2.367a.751.751 0 0 0 .75 1.299l4.101-2.367a.752.752 0 0 0 .275-1.025.751.751 0 0 0-1.025-.274zM20.248 15.411l-6.041 12.083a2.249 2.249 0 0 0 2.012 3.256h12.083a2.25 2.25 0 0 0 2.013-3.256l-6.042-12.083a2.25 2.25 0 0 0-4.025 0zm1.342.671a.75.75 0 0 1 1.342 0l6.041 12.083a.748.748 0 0 1-.671 1.085H16.219a.75.75 0 0 1-.67-1.085z" />
                                                <path d="M15.861 30.708a.75.75 0 0 0 .182-1.479.748.748 0 0 1-.494-1.064l.597-1.195a.751.751 0 0 0-.634-1.085c-5.236-.254-9.409-4.586-9.409-9.885 0-5.462 4.435-9.897 9.897-9.897s9.897 4.435 9.897 9.897a9.842 9.842 0 0 1-.782 3.859.748.748 0 0 0 .02.629l1.8 3.601a.75.75 0 0 0 1.294.082A14.63 14.63 0 0 0 30.709 16c0-8.118-6.591-14.709-14.709-14.709S1.291 7.882 1.291 16c0 8.072 6.516 14.634 14.57 14.708zm-1.819-1.644C7.679 28.118 2.791 22.625 2.791 16 2.791 8.71 8.71 2.791 16 2.791S29.209 8.71 29.209 16c0 2.239-.558 4.349-1.543 6.197l-1.038-2.077c.496-1.278.769-2.667.769-4.12C27.397 9.71 22.29 4.603 16 4.603S4.603 9.71 4.603 16c0 5.719 4.221 10.459 9.714 11.273l-.11.221a2.243 2.243 0 0 0-.165 1.57z" />
                                                <path d="M21.445 19.946v5.007a.75.75 0 0 0 1.5 0v-5.007a.75.75 0 0 0-1.5 0z" />
                                                <circle cx={22.195} cy={27.196} r={0.75} />
                                            </svg>
                                        </div>
                                        <div className={`${cl}__carditem--content`}>
                                            <h1>{statisticsData.overdueTickets}</h1>
                                            <p>Overdue Tickets</p>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item md={4} lg={2.4}>
                                    <div className={`${cl}__carditem --yellow`}>
                                        <div className={`${cl}__carditem--image`}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" >
                                                <g data-name={21}>
                                                    <path d="M8 16a8 8 0 1 1 8-8 8.7 8.7 0 0 1-.19 1.76.5.5 0 0 1-1-.22A7.2 7.2 0 0 0 15 8a7 7 0 1 0-3.76 6.21.5.5 0 1 1 .46.88A7.91 7.91 0 0 1 8 16z" />
                                                    <path d="M13.5 14a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 1-.5.5z" />
                                                    <circle cx={13.5} cy={15.5} r={0.5} />
                                                    <path d="M5.08 10.78a.51.51 0 0 1 .14-.7L8 8.23V3.5a.5.5 0 0 1 1 0v5a.51.51 0 0 1-.22.42l-3 2a.55.55 0 0 1-.7-.14z" />
                                                </g>
                                            </svg>
                                        </div>
                                        <div className={`${cl}__carditem--content`}>
                                            <h1>{statisticsData.todayDueTickets}</h1>
                                            <p>Tickets Due Today</p>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item md={4} lg={2.4}>
                                    <div className={`${cl}__carditem --green`}>
                                        <div className={`${cl}__carditem--image`}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={512}
                                                height={512}
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="#000"
                                                    fillRule="evenodd"
                                                    d="M2 12C2 6.477 6.477 2 12 2c1.595 0 3.105.374 4.445 1.04a1 1 0 1 1-.89 1.791 8 8 0 1 0 4.396 6.279 1 1 0 1 1 1.988-.22c.04.365.061.735.061 1.11 0 5.523-4.477 10-10 10S2 17.523 2 12zm19.707-7.707a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L12 12.586l8.293-8.293a1 1 0 0 1 1.414 0z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        </div>
                                        <div className={`${cl}__carditem--content`}>
                                            <h1>{statisticsData.closedTickets}</h1>
                                            <p>Closed Tickets</p>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item md={4} lg={2.4}>
                                    <div className={`${cl}__carditem --orange`}>
                                        <div className={`${cl}__carditem--image`}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={512}
                                                height={512}
                                                fillRule="evenodd"
                                                strokeLinejoin="round"
                                                strokeMiterlimit={2}
                                                clipRule="evenodd"
                                                viewBox="0 0 24 24"

                                            >
                                                <path d="M12 1.25C6.067 1.25 1.25 6.067 1.25 12S6.067 22.75 12 22.75 22.75 17.933 22.75 12 17.933 1.25 12 1.25zm0 1.5c5.105 0 9.25 4.145 9.25 9.25s-4.145 9.25-9.25 9.25S2.75 17.105 2.75 12 6.895 2.75 12 2.75z" />
                                                <path d="M13.25 8v8a.75.75 0 0 0 1.5 0V8a.75.75 0 0 0-1.5 0zM9.25 8v8a.75.75 0 0 0 1.5 0V8a.75.75 0 0 0-1.5 0z" />
                                            </svg>
                                        </div>
                                        <div className={`${cl}__carditem--content`}>
                                            <h1>{statisticsData.onHoldTickets}</h1>
                                            <p>Tickets on Hold</p>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        <div className={`${cl}__charts`}>
                            <Grid container spacing={4}>
                                <Grid item md={6}>
                                    <div className={`${cl}__piechart`}>
                                        <h3 className={`${cl}__piechart--title`}>All Tickets by Priority</h3>
                                        <div className={`${cl}__piechart--content`}>
                                       
                                            <Chart
                                                options={{
                                                    labels: ["Low", "Medium", "High","Urgent"],
                                                    chart: { type: 'donut',sparkline: { enabled: false }, },
                                                    dataLabels: {
                                                        enabled: false
                                                    },
                                                    plotOptions: {
                                                        pie: {
                                                            donut: {
                                                                labels: {
                                                                    show: true,
                                                                    name: {
                                                                        show: true
                                                                    },
                                                                    value: {
                                                                        show: true,
                                                                    },
                                                                    total: {
                                                                        show: true,
                                                                        showAlways: true,
                                                                        formatter: (w) => {
                                                                            return w.globals.seriesTotals.reduce((a, b) => {
                                                                                return a + b
                                                                            }, 0)
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    },
                                                    colors: [
                                                        'rgb(112, 88, 221)',    
                                                        'rgb(255, 223, 0)',   
                                                        'rgb(255, 100, 0)',   
                                                        'rgb(255, 0, 0)'   
                                                    ],
                                                    

                                                    legend: {
                                                        show: true
                                                    },
                                                }}
                                                series={[
                                                    priorityData.low, 
                                                    priorityData.medium, 
                                                    priorityData.high, 
                                                    priorityData.urgent,
                                                  ]}
                                                type="donut"
                                                width="380"
                                            />
                                            
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item md={6}>
                                    <div className={`${cl}__piechart`}>
                                        <h3 className={`${cl}__piechart--title`}>All Tickets by Status</h3>
                                        <div className={`${cl}__piechart--content`}>
                                            <Chart
                                                options={{
                                                    labels: ["Open","Onhold", "Inprogress", "Closed"],
                                                    chart: { type: 'donut', sparkline: { enabled: false },},
                                                    dataLabels: {
                                                        enabled: false
                                                    },
                                                    plotOptions: {
                                                        pie: {
                                                            donut: {
                                                                labels: {
                                                                    show: true,
                                                                    name: {
                                                                        show: true
                                                                    },
                                                                    value: {
                                                                        show: true,
                                                                    },
                                                                    total: {
                                                                        show: true,
                                                                        showAlways: true,
                                                                        formatter: (w) => {
                                                                            return w.globals.seriesTotals.reduce((a, b) => {
                                                                                return a + b
                                                                            }, 0)
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    },
                                                    colors: [
                                                        'rgb(102, 88, 221)',
                                                        'rgb(247, 184, 75)',
                                                        'rgb(100, 184, 75)',
                                                        'rgb(30, 188, 156)',
                                                    ],

                                                    legend: {
                                                        show: true
                                                    },
                                                }}
                                                series={[
                                                    statusData.open, 
                                                    statusData.on_hold, 
                                                    statusData.in_progress, 
                                                    statusData.closed,
                                                  ]}
                                                  type="donut"
                                                  width="380"
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Dashboard;
